import { compose, defaultTo, isEmpty, isNil, prop } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';
import { getPPZ } from 'features/other/organizationStructureMUI/ppz/selectors';

import { NAME } from './constants';

const getRoot = prop(NAME);
export const getEnableActions = compose(prop('enableActions'), getRoot);
export const getProductionInvalid = compose(prop('productionInvalid'), getRoot);

export const isWithoutPpzDisabledNew = createSelector(
	(state, formData) => getPPZ(state, formData),
	(state, formData) => defaultTo(EMPTY_VALUES.OBJECT)(formData),
	(ppz, formData) => {
		if (!isEmpty(formData.seller) && !isEmpty(ppz)) {
			return isEmpty(formData.ppz) || isNil(formData.ppz);
		}
	},
);
